import { DashboardBuildStepDetails } from "./DashboardBuildStepDetails"
import { DashboardPurchaseOrderDetails } from "./DashboardPurchaseOrderDetails"
import { DashboardQuoteDetails } from "./DashboardQuoteDetails"

export class DashboardInformationDetails {
  buildSteps: DashboardBuildStepDetails[]
  customerApprovedQuotes?: DashboardQuoteDetails[]
  purchaseOrders?: DashboardPurchaseOrderDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.buildSteps = json.buildSteps.map((buildStepJson: any) => new DashboardBuildStepDetails(buildStepJson))

    if (json.customerApprovedQuotes) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      this.customerApprovedQuotes = json.customerApprovedQuotes.map((customerApprovedQuoteJson: any) => new DashboardQuoteDetails(customerApprovedQuoteJson))
    }
    
    if (json.purchaseOrders) {
      this.purchaseOrders = json.purchaseOrders as DashboardPurchaseOrderDetails[]
    }
  }
}
